import { getLocale } from '@pb/utils'

import { demoOrDevPrefix } from 'helpers/demoOrDevPrefix'

const locale = getLocale()

export const EXTERNAL_ROUTES = {
  entrance: `https://www.hm.com/entrance.ahtml`,
  index: `${demoOrDevPrefix}/${locale}/index.html`,
  rateAndReview:
    process.env.BRAND_PREFIX === 'monki'
      ? `${demoOrDevPrefix}/${locale}/account/unreviewedproducts`
      : `${demoOrDevPrefix}/${locale}/unreviewedproducts.html`,
  customerService: `${demoOrDevPrefix}/${locale}/customer-service.html`,
  contact: `${demoOrDevPrefix}/${locale}/customer-service/contact.html`,
  payments: `${demoOrDevPrefix}/${locale}/account/payments`,
  clubInfoPage: `${demoOrDevPrefix}/${locale}/member/info.html`,
  homePage: `${demoOrDevPrefix}/${locale}/`,
  login: `${demoOrDevPrefix}/${locale}/login`,
  logout: `${demoOrDevPrefix}/${locale}/logout`,
  editAddressBook: `${demoOrDevPrefix}/${locale}/settings/addressbook`,
  termsAndConditions: `${demoOrDevPrefix}/${locale}/customer-service/legal-and-privacy/terms-and-conditions.html`,
  registerPage: `${demoOrDevPrefix}/${locale}/register`,
  checkout: `${demoOrDevPrefix}/${locale}/checkout`,
  scanAndFind: `${demoOrDevPrefix}/${locale}/customer-service/shopping-at-hm/scan-and-find.html`,
  scanAndFindNL: `${demoOrDevPrefix}/${locale}/customer-service/shopping-at-hm/scanfunctie.html`,
  imageSearch: `${demoOrDevPrefix}/${locale}/customer-service/shopping-at-hm/visual-search.html`,
  forgotPassword: `${demoOrDevPrefix}/${locale}/password/requestSignIn`,
  directMarketingPrivacyPolicy: `/customer-service/legal-and-privacy/privacy-notice-direct-marketing-link.html`, // temporary until settings API is updated with value
  loginCheckout: `${demoOrDevPrefix}/${locale}/login/checkout`,
  hmSustainability: `${demoOrDevPrefix}/${locale}/sustainability-at-hm/our-work/close-the-loop.html`,
  hmSustainabilityHTML: `${demoOrDevPrefix}/${locale}/hm-sustainability/lets-change.html/close-the-loop`,
  hmSustainabilityConscious: `${demoOrDevPrefix}/${locale}/sustainability-at-hm/our-work/lets-change.html`,
  klarnaCheckout: `${demoOrDevPrefix}/${locale}/klarna/checkout`,
  cart: `${demoOrDevPrefix}/${locale}/cart`,
  linkAccountsFormAction: `${demoOrDevPrefix}/${locale}/styleid/linkaccount/j_spring_security_check`,
  personalDataConsent: '/customer-service/consent-of-personal-data/data-usage-info.modal.html',
  registerCheckout: `${demoOrDevPrefix}/${locale}/login/checkout#register`,
  settingsEditNewsletterSubscription: `${demoOrDevPrefix}/account/settings/my-subscriptions`,
  newArrivalsOtherStories: `${demoOrDevPrefix}/${locale}/whats-new/all.html`,
}
